import { Tab, Tabs } from "react-bootstrap";
import { openPopup } from "../../../store/popupSlice"
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

export default function BoltDevelopement({ data }) {
    const dispatch = useDispatch();
  return (
    <>
      <section className="bolt-developement-area zip-feature-area">
        <div className="container">
          <div className="row justify-content-center">

            <div className="col-lg-8">
              <div className="bolt-develope-head">
                <h3 className="heading center-heading">{data && data.titlePart1} <span className="gradiant-color">{data && data.titlePart2}</span> {data && data.titlePart3}</h3>
                <p className="sub-heading">{data && data.description}</p>
              </div>
            </div>

            <div className="col-lg-12">
              <Tabs defaultActiveKey="CUSTOMER" id="uncontrolled-tab-example" className="mb-4">

                <Tab eventKey="CUSTOMER" title="CUSTOMER APP">
                  <div className="bolt-develop-body">
                    <div className="row align-items-center  justify-content-between">
                      <div className="col-lg-6 col-md-6 order-2 order-md-1">
                        <div className="bolt-develop-content">
                          <h4>{data && data.customer.title}</h4>
                          <p>{data && data.customer.description}</p>
                          <div className="row">
                            {data && data.customer.boxes.map((box, index) => (
                              <div key={index} className="col-lg-6 col-md-6">
                                <div className="bolt-develop-box">
                                  <span>{box.title}</span>
                                  <p>{box.desc}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-5 col-md-6 order-1 order-md-2">
                        <img loading="lazy" src={data && data.customer.image} alt="feature" className="img-responsive" />
                      </div>
                    </div>
                  </div>
                </Tab>

                <Tab eventKey="DRIVER" title="DRIVER APP">
                  <div className="bolt-develop-body">
                    <div className="row align-items-center  justify-content-between">
                      <div className="col-lg-6 col-md-6 order-2 order-md-1">
                        <div className="bolt-develop-content">
                          <h4>{data && data.driver.title}</h4>
                          <p>{data && data.driver.description}</p>
                          <div className="row">
                            {data && data.driver.boxes.map((box, index) => (
                              <div key={index} className="col-lg-6 col-md-6">
                                <div className="bolt-develop-box">
                                  <span>{box.title}</span>
                                  <p>{box.desc}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-5 col-md-6 order-1 order-md-2">
                        <img loading="lazy" src={data && data.driver.image} alt="feature" className="img-responsive" />
                      </div>
                    </div>
                  </div>
                </Tab>

                <Tab eventKey="Dispatcher" title="Dispatcher Dashboard">
                  <div className="bolt-develop-body">
                    <div className="row align-items-center  justify-content-between">
                      <div className="col-lg-6 col-md-6 order-2 order-md-1">
                        <div className="bolt-develop-content">
                          <h4>{data && data.dispatcher.title}</h4>
                          <p>{data && data.dispatcher.description}</p>
                          <div className="row">
                            {data && data.dispatcher.boxes.map((box, index) => (
                              <div key={index} className="col-lg-6 col-md-6">
                                <div className="bolt-develop-box">
                                  <span>{box.title}</span>
                                  <p>{box.desc}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-5 col-md-6 order-1 order-md-2">
                        <img loading="lazy" src={data && data.dispatcher.image} alt="feature" className="img-responsive" />
                      </div>
                    </div>
                  </div>
                </Tab>

                <Tab eventKey="ADMIN" title="ADMIN PANEL">
                  <div className="bolt-develop-body">
                    <div className="row align-items-center  justify-content-between">
                      <div className="col-lg-6 col-md-6 order-2 order-md-1">
                        <div className="bolt-develop-content">
                          <h4>{data && data.admin.title}</h4>
                          <p>{data && data.admin.description}</p>
                          <div className="row">
                            {data && data.admin.boxes.map((box, index) => (
                              <div key={index} className="col-lg-6 col-md-6">
                                <div className="bolt-develop-box">
                                  <span>{box.title}</span>
                                  <p>{box.desc}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-5 col-md-6 order-1 order-md-2">
                        <img loading="lazy" src={data && data.admin.image} alt="feature" className="img-responsive" />
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>

            <div className="col-lg-12 text-center">
              <button onClick={() => dispatch(openPopup())} className="default-btn">{data && data.btn}</button>
              <Link to="/features/taxi-software" className="default-btn">Explore More</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
